// src/lib/utils/logger.ts
// Production-safe logger — replaces console.* throughout the app
// In production, error/warn go to console; debug/info are suppressed
// © 2025–2026 MCX Services, LLC. All rights reserved.

const isProd = import.meta.env.PROD

export const logger = {
  error: (...args: unknown[]) => {
    console.error('[QXProveIt]', ...args)
  },

  warn: (...args: unknown[]) => {
    console.warn('[QXProveIt]', ...args)
  },

  info: (...args: unknown[]) => {
    if (!isProd) {
      console.info('[QXProveIt]', ...args)
    }
  },

  debug: (...args: unknown[]) => {
    if (!isProd) {
      console.debug('[QXProveIt]', ...args)
    }
  },
}
